import {useEffect} from 'react'
import {
	ROLE_COMPETITION_MANAGER,
	ROLE_FIELD_MANAGER,
} from 'shared/constant/lookup/role'

import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useFetch from 'shared/model/useFetch'
import useRoleCookie from 'shared/model/useRoleCookie'

const useGetQualificationCreateList = () => {
	const [fetchResult, fetchRequest] = useFetch()
	const [, setAlert] = useAlertModalAtom()
	const [userRole] = useRoleCookie()

	useEffect(() => {
		// if (
		// 	userRole === ROLE_COMPETITION_MANAGER ||
		// 	userRole === ROLE_FIELD_MANAGER
		// ) {
		// 	fetchRequest('GET', `/admin/exam/qualification-list`)
		// }
		fetchRequest('GET', `/admin/exam/qualification-list`)
	}, [userRole])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				setAlert('필기 시험 idx 입력 양식을 확인해 주세요.')
				break
			case 404:
				if (fetchResult?.data?.error_code === 1)
					setAlert('필기 시험 데이터가 존재하지 않습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult]
}

export default useGetQualificationCreateList
